import type SubjectAddress from '@Domain/Subjects/SubjectAddress';
/** `POST …/workflow-runs/{run}/steps/{step}/retries` carries no body: the target is entirely in the
 * URL. */
class RetryWorkflowStep {
	constructor(
		public readonly facilityId: number,
		public readonly subject: SubjectAddress,
		public readonly runId: number,
		public readonly stepId: number,
	) {
		Object.freeze(this);
	}
}

export default RetryWorkflowStep;
